import { AlKamel } from '../alkamel/index.js';
import { GTPTelemetry } from './gtpTelemetry.js';

const VFT_STAT = ['VFT', 'numeric', 'Virtual Fuel Tank % energy remaining (GTP only)'];

export class IMSA extends AlKamel {
  start(connectionService) {
    this.vftLevels = {};

    this._telemetry = new GTPTelemetry(connectionService);
    this._telemetry.on('telemetry', this.handleTelemetryData.bind(this));

    this.usingGTPTelemetry = false;

    super.start(connectionService);

  }

  handleTelemetryData(telemetry) {
    let changed = false;

    for (const tel of telemetry) {
      const carNum = tel.scoring.number;
      const vft = tel.energy_remaining;
      if (this.vftLevels[carNum] != vft) {
        this.vftLevels[carNum] = vft;
        changed = true;
      }
    }

    if (changed) {
      // Trigger timing state refresh on telemetry as well as collections changes
      const collections = this.sessionMonitor._currentSessionCollections();
      this.handleDataChange(collections);
    }
  }

  handleDataChange(collections) {
    const classesData = collections.session_classes;
    const classesInSession = Object.keys(classesData.classes);

    if (classesInSession.includes('GTP')) {
      if (!this._telemetry.open) {
        this.usingGTPTelemetry = true;
        this._telemetry.start();
      }
    } else if (this._telemetry.open) {
      this.usingGTPTelemetry = false;
      this._telemetry.stop();
    }

    super.handleDataChange(collections);
  }

  getManifest(collections) {
    const manifest = super.getManifest(collections);

    if (this.usingGTPTelemetry) {
      manifest.colSpec.splice(-1, 0, VFT_STAT);
    }

    return manifest;
  }

  translate(collections) {
    const newState = super.translate(collections);

    if (this.usingGTPTelemetry) {
      for (const car of newState.cars) {
        const level = this.vftLevels[car[0]];
        let flag = '';

        if (level !== undefined) {
          if (level < 10) {
            flag = 'red';
          }
          else if (level < 25) {
            flag = 'yellow';
          }
        }

        car.splice(-1, 0, [level || '', flag]);
      }
    }

    return newState;
  }

}

IMSA.regex = /livetiming.alkamelsystems\.com\/imsa/;
